<template>
  <div>
    <md-table
      :value="tableData"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort"
      class="paginated-table table-striped table-hover table-bordered"
      :md-fixed-header="false"
    >
      <md-table-toolbar>
        <md-field>
          <label>Per page</label>
          <md-select v-model="pagination.perPage" name="pages">
            <md-option
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
              {{ item }}
            </md-option>
          </md-select>
        </md-field>
      </md-table-toolbar>
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <!-- eslint-disable -->
        <md-table-cell
          v-for="(column, key) in columns"
          :key="key"
          :md-label="column"
          :md-sort-by="key"
        >
          <div v-if="key === 'nation'" class="nation-flag">
            <progressive-img :src="item[key]" fallback="img/faces/logo.png" />
          </div>
          <div v-else-if="key === 'avatar'" class="program-logo">
            <progressive-img :src="item[key]" fallback="img/faces/logo.png" />
          </div>
          <span v-else>
            {{ item[key] }}
          </span>
        </md-table-cell>
        <md-table-cell v-if="!hideAction" md-label="Actions">
          <md-button
            class="md-just-icon md-info md-simple"
            @click.native="showFormView(item)"
          >
            <md-tooltip md-direction="top">{{ $t("common.view") }}</md-tooltip>
            <md-icon>remove_red_eye</md-icon>
          </md-button>
          <md-button
              class="md-just-icon md-warning md-simple"
              @click.native="manageScore(item)"
          >
            <md-tooltip md-direction="top">{{
                $t("program.manage_score")
              }}</md-tooltip>
            <md-icon>open_in_new</md-icon>
          </md-button>
          <md-button
            class="md-just-icon md-danger md-simple"
            @click.native="confirmDelete(item)"
          >
            <md-tooltip md-direction="top">{{
              $t("common.delete")
            }}</md-tooltip>
            <md-icon>close</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "ProgramTable",
  data() {
    return {
      perPageOptions: [5, 10, 25, 50],
      currentSort: "name",
      currentSortOrder: "asc",
      searchQuery: ""
    };
  },
  components: {},
  props: ["tableData", "pagination", "columns", "hideAction"],
  mounted() {},
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          if (_.isNumber(a[sortBy]) && _.isNumber(b[sortBy])) {
            return a[sortBy]
              .toString()
              .localeCompare(b[sortBy].toString(), undefined, {
                numeric: true
              });
          }
          return a[sortBy].localeCompare(b[sortBy]);
        }
        if (_.isNumber(a[sortBy]) && _.isNumber(b[sortBy])) {
          return b[sortBy]
            .toString()
            .localeCompare(a[sortBy].toString(), undefined, {
              numeric: true
            });
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    showFormView(item) {
      this.$router.push({
        name: "ProgramEditForm",
        params: { id: item.id }
      });
    },
    confirmDelete(item) {
      this.$emit("confirmDelete", item);
    },

    manageScore(item) {
      this.$router.push({
        name: "ManageProgramRatings",
        params: { id: item.id }
      });
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path;
    }
  }
};
</script>

<style scoped="scss" lang="scss">
.md-table-cell {
  word-break: break-all;
}
.nation-flag {
  max-width: 60px;
}
.program-logo {
  width: 50px;
  height: 50px;
  overflow: hidden;
  float: left;
  z-index: 5;
  border-radius: 50%;
  -webkit-box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
    0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
    0 4px 25px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
  -webkit-transition: opacity 300ms linear, -webkit-transform 300ms linear;
  transition: transform 300ms linear, opacity 300ms linear,
    -webkit-transform 300ms linear;
}
</style>
